<template>
  <b-list-group>
    <b-list-group-item v-for="tx in txs"
                       v-bind:key="tx['transaction']['hash']"
                       class="tx_list_item"
                       v-bind:class="$mq">
      <TxSummary v-bind:tx="tx" />
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import TxSummary  from '../TxSummary'

export default {
  name: 'LiveTxsList',

  components : {
    TxSummary
  },

  computed : {
    txs : function(){
      return this.$store.state.txs;
    }
  }
}
</script>

<style scoped>
.tx_list_item.sm{
  padding: 5px;
}

.tx_list_item:first-child{
  border-top-left-radius:  0;
  border-top-right-radius: 0;
}
</style>
